import { SelectionPanel } from '$tablet-app/src/app/components/SelectionPanel';
import Text from '$tablet-app/src/app/components/Text';
import { FontAwesomeIcon } from '@fortawesome/react-native-fontawesome';
import React from 'react';
import styled from 'styled-components/native';
import { useMealPreferenceDialogState } from '../../store/useMealPreferenceDialogState';

const DietaryBalancePreferenceView = () => {
  const dietary_balance = useMealPreferenceDialogState(
    (state) => state.draft_preferences.dietary_balance
  );

  const update = useMealPreferenceDialogState(
    (state) => state.updatePreference
  );

  const onChangeSlider = (dietary_balance: number) =>
    update({ dietary_balance });

  return (
    <Container>
      <Text weight="semibold">
        Choose the amount between veggies and meat/fish
      </Text>
      <PanelRow>
        <Panel
          title="Extra veggies"
          value={0}
          backgroundColor="#DDF5EE"
          onPress={onChangeSlider}
          selected={dietary_balance === 0}
          renderIcon={() => (
            <Icons>
              <FontAwesomeIcon
                size={40}
                icon={['fad', 'salad']}
                secondaryColor="#059669"
                secondaryOpacity={1}
                color="#A6C2D4"
              />
              <FontAwesomeIcon size={20} icon="drumstick" color="#CF9B07" />
            </Icons>
          )}
        />
        <Panel
          title="Slightly more veggies"
          value={1}
          backgroundColor="#E6F9E1"
          onPress={onChangeSlider}
          selected={dietary_balance === 1}
          renderIcon={() => (
            <Icons>
              <FontAwesomeIcon
                size={35}
                icon={['fad', 'salad']}
                secondaryColor="#059669"
                secondaryOpacity={1}
                color="#A6C2D4"
              />
              <FontAwesomeIcon size={25} icon="drumstick" color="#CF9B07" />
            </Icons>
          )}
        />
        <Panel
          title="Half veggies, half meat"
          value={2}
          backgroundColor="rgba(255, 191, 9, 0.15)"
          onPress={onChangeSlider}
          selected={dietary_balance === 2}
          renderIcon={() => (
            <Icons>
              <FontAwesomeIcon
                size={30}
                icon={['fad', 'salad']}
                secondaryColor="#059669"
                secondaryOpacity={1}
                color="#A6C2D4"
              />
              <FontAwesomeIcon size={30} icon="turkey" color="#CF9B07" />
            </Icons>
          )}
        />
        <Panel
          title="Slightly more meat"
          value={3}
          backgroundColor="#FFF2E3"
          onPress={onChangeSlider}
          selected={dietary_balance === 3}
          renderIcon={() => (
            <Icons>
              <FontAwesomeIcon
                size={25}
                icon={['fad', 'salad']}
                secondaryColor="#059669"
                secondaryOpacity={1}
                color="#A6C2D4"
              />
              <FontAwesomeIcon size={35} icon="turkey" color="#CF9B07" />
            </Icons>
          )}
        />
        <Panel
          title="Extra meat"
          value={4}
          backgroundColor="rgba(255, 209, 189, 0.6)"
          onPress={onChangeSlider}
          selected={dietary_balance === 4}
          renderIcon={() => (
            <Icons>
              <FontAwesomeIcon
                size={20}
                icon={['fad', 'salad']}
                secondaryColor="#059669"
                secondaryOpacity={1}
                color="#A6C2D4"
              />
              <FontAwesomeIcon size={40} icon="turkey" color="#CF9B07" />
            </Icons>
          )}
        />
      </PanelRow>
    </Container>
  );
};

const Container = styled.View`
  padding: 30px;
  padding-top: 0;
  align-items: center;
  gap: 30px;
`;

const Panel = styled(SelectionPanel)`
  width: 200px;
  text-align: center;
`;

const PanelRow = styled.View`
  flex-direction: row;
  gap: 30px;
`;

const Icons = styled.View`
  flex-direction: row;
  align-items: flex-end;
  gap: 5px;
`;

export default DietaryBalancePreferenceView;
